import React from "react";

const CupTable = () => {
  return (
    <>
      <section className="about-area pb-60 pt-60">
        <div className="container">
        <h2 className='pb-1' data-aos="fade-up" data-aos-delay="100">NASCAR CRAFTSMAN TRUCK SERIES PAGE</h2>
        <p className='pb-1 lh-base' data-aos="fade-up" data-aos-delay="100">The NASCAR Camping World Truck Series was formerly known as the SuperTruck Series by Craftsman (1995), the Craftsman Truck Series (1996-2008), the Camping World Truck Series (2009-2018), the Gander Outdoors Truck Series (2019-2020), the Camping World Truck Series (2021-2022) and the Craftsman Truck Series (2023).</p>
       
          <table className="table  table-dark table-striped table-bordered border-light">
            <thead>
              <tr style={{ width: "100%" }}>
                <th scope="col"  style={{ textAlign: "center", width: "5%" }}>
                Year
                </th>
                <th scope="col"  style={{ textAlign: "center", width: "5%" }}>
                Races
                </th>
                <th scope="col"  style={{ textAlign: "center", width: "15%" }}>
                Champion
                </th>
                <th scope="col"  style={{ textAlign: "center", width: "15%" }}>
                Car Owner
                </th>
                <th scope="col"  style={{ textAlign: "center", width: "15%" }}>
                Champion's Crew Chief
                </th>
                <th scope="col"  style={{ textAlign: "center", width: "15%" }}>
                Rookie of the Year
                </th>
                <th scope="col"  style={{ textAlign: "center", width: "15%" }}>
                Most Popular Driver
                </th>
                <th scope="col" style={{ textAlign: "center", width: "15%" }}>
                Manufacturers' Championship
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ textAlign: "center" }}>2023</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Ryan Blaney</td>
                <td style={{ textAlign: "center" }}>Roger Penske</td>
                <td style={{ textAlign: "center" }}>Jonathan Hassler</td>
                <td style={{ textAlign: "center" }}>Ty Gibbs</td>
                <td style={{ textAlign: "center" }}></td>
                <td style={{ textAlign: "center" }}>Chevrolet</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2022</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Joey Logano</td>
                <td style={{ textAlign: "center" }}>Roger Penske</td>
                <td style={{ textAlign: "center" }}>Paul Wolfe</td>
                <td style={{ textAlign: "center" }}>Austin Cindric</td>
                <td style={{ textAlign: "center" }}>Chase Elliott</td>
                <td style={{ textAlign: "center" }}>Chevrolet</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2021</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Kyle Larson</td>
                <td style={{ textAlign: "center" }}>Rick Hendrick</td>
                <td style={{ textAlign: "center" }}>Cliff Daniels</td>
                <td style={{ textAlign: "center" }}>Chase Briscoe</td>
                <td style={{ textAlign: "center" }}>Chase Elliott</td>
                <td style={{ textAlign: "center" }}>Chevrolet</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2023</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Ryan Blaney</td>
                <td style={{ textAlign: "center" }}>Roger Penske</td>
                <td style={{ textAlign: "center" }}>Jonathan Hassler</td>
                <td style={{ textAlign: "center" }}>Ty Gibbs</td>
                <td style={{ textAlign: "center" }}></td>
                <td style={{ textAlign: "center" }}>Chevrolet</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2022</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Joey Logano</td>
                <td style={{ textAlign: "center" }}>Roger Penske</td>
                <td style={{ textAlign: "center" }}>Paul Wolfe</td>
                <td style={{ textAlign: "center" }}>Austin Cindric</td>
                <td style={{ textAlign: "center" }}>Chase Elliott</td>
                <td style={{ textAlign: "center" }}>Chevrolet</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2021</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Kyle Larson</td>
                <td style={{ textAlign: "center" }}>Rick Hendrick</td>
                <td style={{ textAlign: "center" }}>Cliff Daniels</td>
                <td style={{ textAlign: "center" }}>Chase Briscoe</td>
                <td style={{ textAlign: "center" }}>Chase Elliott</td>
                <td style={{ textAlign: "center" }}>Chevrolet</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2023</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Ryan Blaney</td>
                <td style={{ textAlign: "center" }}>Roger Penske</td>
                <td style={{ textAlign: "center" }}>Jonathan Hassler</td>
                <td style={{ textAlign: "center" }}>Ty Gibbs</td>
                <td style={{ textAlign: "center" }}></td>
                <td style={{ textAlign: "center" }}>Chevrolet</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2022</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Joey Logano</td>
                <td style={{ textAlign: "center" }}>Roger Penske</td>
                <td style={{ textAlign: "center" }}>Paul Wolfe</td>
                <td style={{ textAlign: "center" }}>Austin Cindric</td>
                <td style={{ textAlign: "center" }}>Chase Elliott</td>
                <td style={{ textAlign: "center" }}>Chevrolet</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2021</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Kyle Larson</td>
                <td style={{ textAlign: "center" }}>Rick Hendrick</td>
                <td style={{ textAlign: "center" }}>Cliff Daniels</td>
                <td style={{ textAlign: "center" }}>Chase Briscoe</td>
                <td style={{ textAlign: "center" }}>Chase Elliott</td>
                <td style={{ textAlign: "center" }}>Chevrolet</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2023</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Ryan Blaney</td>
                <td style={{ textAlign: "center" }}>Roger Penske</td>
                <td style={{ textAlign: "center" }}>Jonathan Hassler</td>
                <td style={{ textAlign: "center" }}>Ty Gibbs</td>
                <td style={{ textAlign: "center" }}></td>
                <td style={{ textAlign: "center" }}>Chevrolet</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2022</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Joey Logano</td>
                <td style={{ textAlign: "center" }}>Roger Penske</td>
                <td style={{ textAlign: "center" }}>Paul Wolfe</td>
                <td style={{ textAlign: "center" }}>Austin Cindric</td>
                <td style={{ textAlign: "center" }}>Chase Elliott</td>
                <td style={{ textAlign: "center" }}>Chevrolet</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2021</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Kyle Larson</td>
                <td style={{ textAlign: "center" }}>Rick Hendrick</td>
                <td style={{ textAlign: "center" }}>Cliff Daniels</td>
                <td style={{ textAlign: "center" }}>Chase Briscoe</td>
                <td style={{ textAlign: "center" }}>Chase Elliott</td>
                <td style={{ textAlign: "center" }}>Chevrolet</td>
              </tr>
          
            </tbody>
          </table>
      
       
        </div>
      </section>
    </>
  );
};

export default CupTable;
